import React from 'react';

const Address = () => {
    return (
        <div>
            <h1>This is Address Box</h1>
        </div>
    );
};

export default Address;